var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1C2022",
    fillRule: "nonzero",
    d: "M5.08 5.36V.88c0-.32.21-.581.47-.581s.47.26.47.581V5.36l2.42-2.242a.46.46 0 0 1 .664.053.5.5 0 0 1-.051.688l-3.197 2.95a.458.458 0 0 1-.612 0l-3.197-2.95a.5.5 0 0 1-.05-.688.46.46 0 0 1 .663-.053L5.08 5.36zm5.079 3.665V7.562c0-.269.21-.487.47-.487s.471.218.471.487v1.95a.48.48 0 0 1-.47.488H.47A.48.48 0 0 1 0 9.512v-1.95c0-.269.21-.487.47-.487s.471.218.471.487v1.463h9.218z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.c61d011472036c8ec4ce05fe7dba6825.svg";
export { ForwardRef as ReactComponent };